import React, { useState, useEffect } from 'react'
import ColorButton from '../Buttons/ColorButton'
import apptheme from '../theme/default'
import { Box } from '@mui/material'
import './styles.css'
import DefButton from '../Buttons/defbutton'
import ReplyIcon from '@mui/icons-material/Reply';
import { useWindowSize } from "@uidotdev/usehooks";
import { hasPermissions } from '../Utils/groups'
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import Colaboradores from './Colaborador'
import ClientesDesconsiderados from './ClientesDesconsiderados'
import UsersElevor from './UsersElevor'
import Sellers from './Vendedores'
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import DescontoVolume from './DescontoVolume'



const MenuList = () => {

    // const user = getSession()
    // const permissions = user?.permissions

    return ({
        'colaboradores': {
            title: 'Colaboradores',
            icon: (<PersonAddIcon />),
            obj: (<Colaboradores />),
            permission: (false)
        },
        'colaborador_elevor': {
            title: 'Colaboradores Elevor',
            icon: (<PeopleAltIcon />),
            obj: (<UsersElevor />),
            permission: (hasPermissions('administrador', 'grupo_administradores'))
        },
        'sellers': {
            title: 'Vendedores',
            icon: (<LoyaltyIcon />),
            obj: (<Sellers />),
            permission: (hasPermissions('administrador', 'grupo_administradores'))
        },
        'clientes_desconsiderados': {
            title: 'Clientes Desconsiderados',
            icon: (<PeopleAltIcon />),
            obj: (<ClientesDesconsiderados />),
            permission: (hasPermissions('administrador', 'grupo_administradores'))
        },
         'volume_discount': {
            title: 'Desconto de volume',
            icon: (<PeopleAltIcon />),
            obj: (<DescontoVolume />),
            permission: (hasPermissions('administrador', 'grupo_administradores'))
        },

    })
}

const CalcWidthSize = (size) => {
    const threshold = size?.width < 768 ? 200 : 400
    const calcSize = Math.round(size?.width / threshold)
    if (!calcSize)
        return 2
    return calcSize
}

const Cadastros = () => {

    const [selectedTab, setSelectedTab] = useState()
    const size = useWindowSize();

    const menulist = MenuList()

    const calcSize = CalcWidthSize(size)

    const itens = Object.entries(menulist).filter(([key, value]) => value.permission)

    useEffect(() => {
        window.backtobase = () => setSelectedTab()
    }, [])

    return (
        <>
            {!selectedTab ?
                <>
                    <Box className='gridBox' sx={{ gridTemplateColumns: `repeat(${calcSize}, minMax(0, 1fr))` }}>
                        {itens.map(([key, value]) => (
                            <ColorButton
                                onClick={() => setSelectedTab(key)}
                                sx={{ height: '8rem', flex: 1, visibility: !value.obj ? 'hidden' : 'visible' }}
                                fColor={apptheme.primaryColor}
                                sColor={apptheme.tertiaryColor}>
                                <Box className='flexbox'>
                                    {value.icon}
                                    {value.title}
                                </Box>
                            </ColorButton>

                        ))}
                    </Box>
                </>
                :
                <>
                    <Box className='settings-back-button'>
                        <DefButton
                            onClick={() => setSelectedTab()}
                        >
                            <ReplyIcon />
                        </DefButton>
                    </Box>
                    {MenuList()[selectedTab].obj}
                </>
            }

        </>
    )
}

export default Cadastros;